import React, { FC } from 'react';

type PropsT = {
  fill?: string;
  onClick?: () => void;
};

const EditIcon: FC<PropsT> = ({ fill = 'currentColor', ...rest }) => (
  <svg {...rest} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.37437 25.6256L7.42021 21.4423L21.7412 7.12132C22.1317 6.7308 22.7649 6.73079 23.1554 7.12132L24.8787 8.84462C25.2692 9.23514 25.2692 9.86831 24.8787 10.2588L10.5577 24.5798L6.37437 25.6256Z"
      stroke="#8E9193" strokeWidth="2"/>
    <rect x="19.6199" y="10.4141" width="0.876729" height="3.83644" transform="rotate(-45 19.6199 10.4141)"
          stroke="#8E9193" strokeWidth="0.876729"/>
  </svg>
);

const EditIcon24: FC<PropsT> = ({ fill = 'currentColor', ...rest }) => (
  <svg {...rest}  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.2166 2.43934C17.8023 1.85355 18.7521 1.85355 19.3379 2.43934L21.4237 4.52513C22.0094 5.11091 22.0094 6.06066 21.4237 6.64645L7.33668 20.7334C7.13496 20.9352 6.8799 21.0752 6.60141 21.1371L3.21808 21.8889C2.47245 22.0546 1.82384 21.357 2.04333 20.6254L3.22586 16.6836C3.29719 16.4458 3.42641 16.2295 3.60194 16.054L17.2166 2.43934ZM18.6308 3.14645C18.4355 2.95118 18.1189 2.95118 17.9237 3.14645L15.9843 5.08579L18.7772 7.87868L20.7166 5.93934C20.9118 5.74408 20.9118 5.4275 20.7166 5.23223L18.6308 3.14645ZM18.0701 8.58579L15.2772 5.79289L4.30904 16.7611C4.25053 16.8196 4.20746 16.8917 4.18368 16.9709L3.00115 20.9127L6.38448 20.1609C6.47731 20.1402 6.56233 20.0936 6.62957 20.0263L18.0701 8.58579Z" fill="#909090"/>
  </svg>
)

export default EditIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
  onClick?: () => void;
};

const EditIcon: FC<PropsT> = ({ fill = 'currentColor', ...rest }) => (
  <svg {...rest} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.37437 25.6256L7.42021 21.4423L21.7412 7.12132C22.1317 6.7308 22.7649 6.73079 23.1554 7.12132L24.8787 8.84462C25.2692 9.23514 25.2692 9.86831 24.8787 10.2588L10.5577 24.5798L6.37437 25.6256Z"
      stroke="#8E9193" strokeWidth="2"/>
    <rect x="19.6199" y="10.4141" width="0.876729" height="3.83644" transform="rotate(-45 19.6199 10.4141)"
          stroke="#8E9193" strokeWidth="0.876729"/>
  </svg>
);

const EditIcon24: FC<PropsT> = ({ fill = 'currentColor', ...rest }) => (
  <svg {...rest}  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.2166 2.43934C17.8023 1.85355 18.7521 1.85355 19.3379 2.43934L21.4237 4.52513C22.0094 5.11091 22.0094 6.06066 21.4237 6.64645L7.33668 20.7334C7.13496 20.9352 6.8799 21.0752 6.60141 21.1371L3.21808 21.8889C2.47245 22.0546 1.82384 21.357 2.04333 20.6254L3.22586 16.6836C3.29719 16.4458 3.42641 16.2295 3.60194 16.054L17.2166 2.43934ZM18.6308 3.14645C18.4355 2.95118 18.1189 2.95118 17.9237 3.14645L15.9843 5.08579L18.7772 7.87868L20.7166 5.93934C20.9118 5.74408 20.9118 5.4275 20.7166 5.23223L18.6308 3.14645ZM18.0701 8.58579L15.2772 5.79289L4.30904 16.7611C4.25053 16.8196 4.20746 16.8917 4.18368 16.9709L3.00115 20.9127L6.38448 20.1609C6.47731 20.1402 6.56233 20.0936 6.62957 20.0263L18.0701 8.58579Z" fill="#909090"/>
  </svg>
)

export default EditIcon;
